import React from "react";
import Box from "@mui/material/Box";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import CustomFormControlLabel from "../styledComponents/customFormControlLabel.component";
import { changeTitleProps as Props } from "../../types/index";

const FormTitleInput: React.FC<Props> = ({ onInputChange, title }) => {
  const titles = ["Dr.", "Prof.", "Mr.", "Ms.", "Mrs."];

  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          mt: { xs: "20px", sm: "22px", md: "24px" },
        }}
      >
        <FormControl component="fieldset" required={true}>
          <RadioGroup
            aria-label="title"
            defaultValue="Dr."
            name="radio-buttons-group"
            value={title}
            onChange={(e) => onInputChange(e)}
            sx={{
              fontFamily: "Avenir",
            }}
          >
            {titles.map((title, index) => (
              <React.Fragment key={index}>
                <CustomFormControlLabel value={title} />
              </React.Fragment>
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
    </React.Fragment>
  );
};

export default FormTitleInput;
